import { Controller } from "@hotwired/stimulus"

// Shows/hides a back-to-top button based on scroll position
// Usage: data-controller="back-to-top"
//        data-back-to-top-target="button" on the button element
export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.scrollHandler = this.throttle(this.onScroll.bind(this), 150)
    window.addEventListener("scroll", this.scrollHandler, { passive: true })
    this.onScroll()
  }

  disconnect() {
    window.removeEventListener("scroll", this.scrollHandler)
  }

  onScroll() {
    if (window.scrollY > 600) {
      this.buttonTarget.classList.remove("opacity-0", "pointer-events-none")
      this.buttonTarget.classList.add("opacity-100")
    } else {
      this.buttonTarget.classList.remove("opacity-100")
      this.buttonTarget.classList.add("opacity-0", "pointer-events-none")
    }
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  throttle(fn, wait) {
    let lastTime = 0
    return function (...args) {
      const now = Date.now()
      if (now - lastTime >= wait) {
        lastTime = now
        fn.apply(this, args)
      }
    }
  }
}
